import React from 'react';

import ProfileComponent from 'components/Profile';

const Profile: React.FC = () => <ProfileComponent />;

export default Profile;
